var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ height: _vm.level * 10 + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }